import { eventWithTime } from 'sb-lib/types';

export const makeClearingEvent = (timestamp: number) =>
  ({
    type: 2,
    data: {
      node: {
        type: 0,
        childNodes: [
          {
            type: 1,
            name: 'html',
            publicId: '',
            systemId: '',
            id: 2,
          },
          {
            type: 2,
            tagName: 'html',
            attributes: {
              lang: 'en',
            },
            childNodes: [
              {
                type: 2,
                tagName: 'head',
                attributes: {},
                childNodes: [],
                id: 4,
              },
              {
                type: 2,
                tagName: 'body',
                attributes: {
                  style: 'margin: 0; overflow: hidden; width: 100vw; height: 100vh;',
                  class: '',
                },
                childNodes: [],
                id: 34,
              },
            ],
            id: 3,
          },
        ],
        id: 1,
      },
      initialOffset: {
        left: 0,
        top: 0,
      },
    },
    timestamp: timestamp,
  } as eventWithTime);
